import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  WithdrawalVipPreferredComponent } from './withdrawal-vip-widget.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from 'src/app/components/components.module';
import { PipesModule } from 'src/app/pipes/pipes.module';


@NgModule({
  declarations: [
    WithdrawalVipPreferredComponent
  ],
  imports: [
    CommonModule,
    IonicModule,
    ReactiveFormsModule,
    ComponentsModule,
    PipesModule,
    FormsModule,
  ],
  exports:[
    WithdrawalVipPreferredComponent
  ]
})
export class WithdrawalVipWidgetModule { }
